var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { BlueButton } from '@hn-ui/buttons';
import { Spinner } from '@hn-ui/icons';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router';
import { StudentsSection } from './StudentsSection';
import { AssignmentSection } from './AssignmentSection';
import { getInvalidFields, validateForm } from './utils';
import { useLazyCreateAssignment } from '../../../../hooks/useLazyCreateAssignment';
import { SuccessModal } from './SuccessModal';
import { DEFAULT_FORM_VALUES } from '../../../../constants/form';
import { AssignmentErrorBoundary, isAssignmentError, } from '../../../../components/ErrorBoundary';
import { useAppGoogleAnalytics } from '../../../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../../../constants/analytics';
import { ASSIGNMENTS_ROUTES } from '../../../../constants/routes';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-16g1kqi" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 72px;\n  gap: 24px 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 72px;\n  gap: 24px 0;\n"])));
var ScSubmit = styled(BlueButton).withConfig({ displayName: "ScSubmit", componentId: "sc-1vpumle" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 16px auto 0;\n  min-width: 265px;\n"], ["\n  margin: 16px auto 0;\n  min-width: 265px;\n"])));
var CreateAssignmentForm = function (_a) {
    var groupId = _a.groupId, formInfo = _a.formInfo, _b = _a.initData, initData = _b === void 0 ? {} : _b, onSubmit = _a.onSubmit;
    var _c = useLazyCreateAssignment(groupId), submitData = _c[0], _d = _c[1], submitLoading = _d.isLoading, error = _d.error;
    var _e = useState(__assign(__assign({}, DEFAULT_FORM_VALUES), initData)), formData = _e[0], setFormData = _e[1];
    var ga = useAppGoogleAnalytics();
    var initGrade = useMemo(function () {
        var _a;
        var targetGrade = (_a = initData.grade) !== null && _a !== void 0 ? _a : formInfo.groupGrade;
        if (targetGrade) {
            var target = formInfo.grades.find(function (el) { return el.id === targetGrade.id; });
            if (target)
                return target;
        }
        return formInfo.grades[0];
    }, [formInfo.grades, formInfo.groupGrade, initData.grade]);
    var onStudentsChange = useCallback(function (students) {
        setFormData(function (val) { return (__assign(__assign({}, val), { students: students })); });
    }, []);
    var onAssignmentDataChange = useCallback(function (data) {
        setFormData(function (val) { return (__assign(__assign({}, val), data)); });
    }, []);
    var isValid = useMemo(function () { return validateForm(formData); }, [formData]);
    var invalidFields = useMemo(function () { return getInvalidFields(formData); }, [formData]);
    var isSubmitEnabled = invalidFields.length === 0 ||
        (invalidFields.length === 1 && invalidFields[0] === 'name');
    var _f = useState(false), showSuccessModal = _f[0], setShowSuccessModal = _f[1];
    var _g = useState(false), showErrors = _g[0], setShowErrors = _g[1];
    var onSubmitForm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (submitLoading)
                        return [2 /*return*/];
                    if (!isValid) {
                        setShowErrors(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, submitData(formData)];
                case 1:
                    data = _a.sent();
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                    if (!isAssignmentError(data)) {
                        setShowSuccessModal(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [formData, isValid, onSubmit, submitData, submitLoading]);
    var resetForm = useCallback(function () {
        setFormData(__assign(__assign({}, DEFAULT_FORM_VALUES), { grade: initGrade, domain: initGrade.domains[0] }));
    }, [initGrade]);
    var navigate = useNavigate();
    var handleModalClose = useCallback(function () {
        resetForm();
        setShowSuccessModal(false);
        navigate(ASSIGNMENTS_ROUTES.assignmentsList);
    }, [resetForm, navigate]);
    var handleModalLinkClick = useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage,
            action: ASSIGNMENTS_EVENTS.assign_add_assignment_page_goback_click,
        });
        navigate(ASSIGNMENTS_ROUTES.assignmentsList);
    }, [ga, navigate]);
    useEffect(function () {
        if (!formData.grade) {
            setFormData(function (val) { return (__assign(__assign({}, val), { grade: initGrade, domain: initGrade.domains[0] })); });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(AssignmentErrorBoundary, __assign({ error: error }, { children: _jsxs(Wrapper, { children: [_jsx(StudentsSection, { students: formInfo.students, selectedStudents: formData.students, onSelect: onStudentsChange, skipAssessments: formInfo.skipAssessments }, void 0), _jsx(AssignmentSection, { grades: formInfo.grades, data: formData, onChange: onAssignmentDataChange, minDate: formInfo.minDate, showErrors: showErrors }, void 0), _jsx(ScSubmit, __assign({ fit: true, disabled: !isSubmitEnabled, onClick: onSubmitForm }, { children: submitLoading ? (_jsx(Spinner, { color: 'black100' }, void 0)) : ('Assign to selected students') }), void 0), isValid && (_jsx(SuccessModal, { open: showSuccessModal, data: formData, onCloseClick: handleModalClose, onLinkClick: handleModalLinkClick }, void 0))] }, void 0) }), void 0));
};
export { CreateAssignmentForm };
var templateObject_1, templateObject_2;
